import { ActionTypeList } from '../../constants'

const initialState = {
    loading: false,
    scanQueueSetting: null,
    error: "",
};


const fetchScanQueueSettingPayload = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypeList.SCAN_QUEUE_SETTING_DATA_FETCHED:
            //console.log(`${new Date()}: action SCAN_QUEUE_SETTING_DATA_FETCHED starts with payload ${JSON.stringify(action.payload)}`);

            return {
                loading: false,
                scanQueueSetting: action.payload,
                error: ""
            };
        case ActionTypeList.SCAN_QUEUE_SETTING_DATA_FETCH:
            return {
                loading: true,
                scanQueueSetting: {
                    NonQueuedTargets: [],
                    Queues: []
                },
                error: action.payload
            };
        default:
            return state;
    }
}

export default fetchScanQueueSettingPayload;
